import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Projects.css';
import { useLanguage } from '../../i18n/LanguageContext';
import { getRandomProjects } from '../../data/projectsData';

const ProjectCard = ({ title, description, image, technologies, imagePosition = 'left', link }) => {
  const imageContent = (
    <div className="projects__card-image">
      {image ? (
        <img src={image} alt={title} className="projects__card-preview" />
      ) : (
        <iframe 
          src={link} 
          title={title}
          className="projects__card-preview"
          loading="lazy"
        />
      )}
    </div>
  );

  const handleClick = () => {
    window.open(link, '_blank', 'noopener,noreferrer');
  };

  return (
    <div 
      className={`projects__card projects__card--${imagePosition}`}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClick();
        }
      }}
    >
      {imagePosition === 'left' && imageContent}

      <div className="projects__card-content">
        <div className="projects__card-text">        
          <h3 className="projects__card-title">{title}</h3>
          <p className="projects__card-description">{description}</p>
        </div>

        <div className="projects__card-tech">
          {technologies.map((tech) => (
            <span key={tech} className="projects__card-tech-tag">
              {tech}
            </span>
          ))}
        </div>
      </div>

      {imagePosition === 'right' && imageContent}
    </div>
  );
};

const Projects = () => {
  const { t, language } = useLanguage();
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    // Seleccionar 3 proyectos aleatorios cuando el componente se monta o cambia el idioma
    const randomProjects = getRandomProjects(3, language);
    setProjects(randomProjects);
  }, [language]);

  return (
    <section className="projects" data-name="Projects" data-node-id="5:632">
      <div className="projects__content">
        <div className="projects__container" data-name="Container" data-node-id="5:633">
          {/* Header */}
          <div className="projects__header" data-name="Row" data-node-id="5:634">
            <div className="projects__header-inner" data-name="Row" data-node-id="5:635">
              <div className="projects__tag" data-name="Tag" data-node-id="5:636">
                <p className="projects__tag-text">{t('projects.tag')}</p>
              </div>
            </div>

            <div className="projects__header-subtitle" data-name="Row" data-node-id="5:637">
              <p className="projects__subtitle" data-node-id="5:638">
                {t('projects.subtitle')}
              </p>
            </div>
          </div>

          {/* Projects */}
          <div className="projects__list">
            {projects.map((project) => (
              <ProjectCard key={project.id} {...project} />
            ))}
          </div>
        </div>

        {/* View All Button */}
        <div className="projects__footer">
          <Link to="/projects" className="projects__view-all">
            {t('projects.viewAll')}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Projects;
